import React from 'react'

import styles from "./textBox.module.scss";
export interface ContentItemsProps{
    title?: string;
    text?: string;
    unit?: string;
    ItemRender ?: React.FC;
 
}

export interface TextBoxProps {
    content: ContentItemsProps[];
    color?: 'primary' | 'secondary';
    variant?: 'dark' | 'light';

    
}

export default function TextBox({content, color = 'secondary', variant ='light', } : TextBoxProps) {

  return (
    <div className={[styles['text-box'],styles['text-box--'+color], styles['text-box--'+variant], styles['text-box--'+variant+'--'+color]].join(" ")}>
        {content.map((item, index) => (
            <div key={index}>
            <div className={[styles['text-container'], styles['text-container--'+variant]].join(" ")}>
                <h2 className={[styles['text-container__title'],styles['text-container__title--'+variant]].join(" ")}>{item.title}</h2>
                { (item.text || item.unit) &&
                    <p className={[styles['text-container__text'],styles['text-container__textle--'+variant]].join(" ")} >{item.text} <span>{item.unit}</span></p>
                }
                { item.ItemRender &&
                    <div className={[styles['text-container__render'], styles['text-container__render--'+variant]].join(" ") }>
                    <item.ItemRender />
                    </div>
                }

            </div>
            </div>
        ))}
    </div>
  )
}

